import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

export const ns = 'source-stream-page';
export const useSourceStreamPageTranslation = (): UseTranslationResponse<typeof ns> => useTranslation(ns);

export const ruRu = (__LOCALE_RU__ ? ({
  sourceStreamPage: {
    back_to_sources: 'Источники',
    save: 'Сохранить',
    delete: 'Удалить',
    save_success: 'Изменения сохранены',
    save_error: 'Не удалось сохранить изменения',
    save_validation_error: 'Исправьте ошибки в полях',
    unsaved_toast: 'Есть несохранённые изменения',
    load_error: 'Не удалось загрузить источник',
    back_to_list: 'Вернуться к источникам',
    zones_modal_title: 'Настройка зон ROI и DROI — {{name}}',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  sourceStreamPage: {
    back_to_sources: 'Sources',
    save: 'Save',
    delete: 'Delete',
    save_success: 'Changes saved',
    save_error: 'Failed to save changes',
    save_validation_error: 'Fix the errors in the fields',
    unsaved_toast: 'There are unsaved changes',
    load_error: 'Failed to load the stream',
    back_to_list: 'Back to sources',
    zones_modal_title: 'ROI/DROI zones — {{name}}',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  sourceStreamPage: {
    back_to_sources: 'Fuentes',
    save: 'Guardar',
    delete: 'Eliminar',
    save_success: 'Cambios guardados',
    save_error: 'No se pudieron guardar los cambios',
    save_validation_error: 'Corrige los errores de los campos',
    unsaved_toast: 'Hay cambios sin guardar',
    load_error: 'No se pudo cargar la fuente',
    back_to_list: 'Volver a fuentes',
    zones_modal_title: 'Configuración de zonas ROI y DROI — {{name}}',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  sourceStreamPage: {
    back_to_sources: 'Fontes',
    save: 'Salvar',
    delete: 'Excluir',
    save_success: 'Alterações salvas',
    save_error: 'Falha ao salvar alterações',
    save_validation_error: 'Corrija os erros nos campos',
    unsaved_toast: 'Há alterações não salvas',
    load_error: 'Falha ao carregar a fonte',
    back_to_list: 'Voltar às fontes',
    zones_modal_title: 'Configuração das zonas ROI e DROI — {{name}}',
  },
}) : {}) as Record<string, unknown>;
